import './style.scss';

interface IUnreadPill {
	count: number;
	/** Pixel size of the pill; `sm` fits inside a row of text, `md` beside a heading. */
	size?: 'sm' | 'md';
	className?: string;
}

/**
 * The unread count, everywhere it appears: the Help hub row, an inbox row, a polling-unit row,
 * the coverage strip and the Message button.
 *
 * <p>One component so the number always looks the same, and so the dark-mode rule that makes a
 * span inside a heading or button take its PARENT's colour (`[data-theme='dark'] .body-container
 * span { color: inherit }`, specificity 0,2,1) is beaten once, here, by doubling the class.</p>
 *
 * <p>Renders nothing at zero — a "0" badge is noise, and callers should not have to guard.</p>
 */
export const UnreadPill = ({ count, size = 'sm', className = '' }: IUnreadPill) => {
	if (count <= 0) return null;
	return (
		<span className={`unread-pill unread-pill unread-pill--${size} ${className}`.trim()}>
			{count > 99 ? '99+' : count}
			<span className='visually-hidden'> unread messages</span>
		</span>
	);
};

export default UnreadPill;
